module.exports = __webpack_public_path__ + "img/tiwer_new.4af1b2e9.png";